module.exports = __webpack_public_path__ + "static/media/videoTaskIcon.f788822f.svg";